import React from 'react';
import UserBlackListTable from './common/UserBlackListTable';
import groupsSearchItem from '../../../components/Hocs/GroupsSearchNewCollector/GroupsSearchItem';

const GroupsSearchItem = groupsSearchItem(UserBlackListTable);

export default props => (
  <GroupsSearchItem
    {...props}
    groupName="blackListByExecutors"
    categoryId={2}
    listReduceName="userBlackList.lists.blackListByExecutors"
  />
);



// WEBPACK FOOTER //
// ./src/components/UserBlackList/UserBlackListTable/UserBlackListByExecutors.js